import { getCatalogue } from './catalogueClient';

export const getModels = async (brandId, options) => {
  if (!brandId) return [];
  return getCatalogue('models', [brandId], 'getModelsV2', { brandId }, options);
};
